//Generated File 
export const EDIT = `EDIT`;
export const NEW = `NEW`;
export const VIEW = `VIEW`;
